import { useFirebaseRemoteConfigStore } from '../config/firebaseRemoteConfigStore';
import { UIConfig } from '../types/firebaseRemoteConfig';

interface UseFirebaseRemoteConfigResult {
  config: UIConfig;
  loading: boolean;
  error: Error | null;
  refetch: (force?: boolean) => Promise<void>;
}

/**
 * Hook to fetch and use Firebase Remote Config for UI configuration
 * Uses Zustand store to ensure config is fetched only once and shared across all components
 * @returns Object containing config, loading state, error, and refetch function
 * - refetch(true) will bypass the cache and force a fresh fetch from Firebase
 * - refetch(false) or refetch() will respect the cache (1 hour interval)
 */
export function useFirebaseRemoteConfig(): UseFirebaseRemoteConfigResult {
  const config = useFirebaseRemoteConfigStore((state) => state.config);
  const loading = useFirebaseRemoteConfigStore((state) => state.loading);
  const error = useFirebaseRemoteConfigStore((state) => state.error);
  const fetchConfig = useFirebaseRemoteConfigStore((state) => state.fetchConfig);

  return {
    config,
    loading,
    error,
    refetch: fetchConfig,
  };
}

/**
 * Hook to specifically get the under maintenance configuration
 */
export function useUnderMaintenanceConfig() {
  const { config, loading, error, refetch } = useFirebaseRemoteConfig();
  const initialize = useFirebaseRemoteConfigStore((state) => state.initialize);

  return {
    underMaintenance: config.under_maintenance,
    loading,
    error,
    refetch,
    initialize,
  };
}
